import React from 'react'
import './StartUpLoader.css'

const StartUpLoader = () => {
  return (
    <div className='loaderBody'>
      <div className='loader'>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
}

export default StartUpLoader